module.exports = __webpack_public_path__ + "static/img/gongzhongzj.fb0ac1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/gongzhongzj.jpg
// module id = scL8
// module chunks = 1